//PRODUCTIVITY_LIST
export const USER_PRODUCTIVITY_REQUEST = 'USER_PRODUCTIVITY_REQUEST';
export const USER_PRODUCTIVITY_SUCCESS = 'USER_PRODUCTIVITY_SUCCESS';
export const USER_PRODUCTIVITY_FAIL = 'USER_PRODUCTIVITY_FAIL';

//PRODUCTIVITY OF MONTH
export const USER_MONTH_PRODUCTIVITY_REQUEST =
  'USER_MONTH_PRODUCTIVITY_REQUEST';
export const USER_MONTH_PRODUCTIVITY_SUCCESS =
  'USER_MONTH_PRODUCTIVITY_SUCCESS';
export const USER_MONTH_PRODUCTIVITY_FAIL = 'USER_MONTH_PRODUCTIVITY_FAIL';

//PRODUCTIVITY OF PREV
export const USER_PREV_PRODUCTIVITY_REQUEST = 'USER_PREV_PRODUCTIVITY_REQUEST';
export const USER_PREV_PRODUCTIVITY_SUCCESS = 'USER_PREV_PRODUCTIVITY_SUCCESS';
export const USER_PREV_PRODUCTIVITY_FAIL = 'USER_PREV_PRODUCTIVITY_FAIL';
